import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { hideToast } from '../../store/uiSlice';

const Toast = () => {
  const dispatch = useDispatch();
  const { toast } = useSelector((state) => state.ui);

  useEffect(() => {
    if (toast.show) {
      const timer = setTimeout(() => {
        dispatch(hideToast());
      }, 3400);
      return () => clearTimeout(timer);
    }
  }, [toast.show, dispatch]);

  if (!toast.show) return null;

  const icons = {
    success: 'fa-circle-check',
    error: 'fa-circle-exclamation',
    warn: 'fa-triangle-exclamation',
    info: 'fa-circle-info',
    buy: 'fa-arrow-trend-up',
    sell: 'fa-arrow-trend-down',
    deposit: 'fa-circle-plus',
    order: 'fa-file-invoice',
  };

  const getColor = (type) => {
    switch (type) {
      case 'success': return 'var(--color-green)';
      case 'error': return 'var(--color-red)';
      case 'warn': return 'var(--color-orange)';
      case 'info': return 'var(--color-blue)';
      case 'buy': return 'var(--color-green)';
      case 'sell': return 'var(--color-red)';
      case 'deposit': return 'var(--color-green)';
      case 'order': return 'var(--color-orange)';
      default: return 'var(--color-orange)';
    }
  };

  const icon = icons[toast.type] || 'fa-circle-info';
  const color = getColor(toast.type);

  return (
    <div className="fixed bottom-5 right-4 z-[1000] rounded-xl px-4 py-3 flex items-center gap-3 text-sm max-w-[340px] shadow-2xl animate-toast-slide"
      style={{ background: 'var(--color-bgSurface)', border: '1px solid var(--color-border)' }}>
      <i className={`fas ${icon}`} style={{ color }} />
      <span className="text-xs md:text-sm" style={{ color: 'var(--color-text)' }}>{toast.message}</span>
    </div>
  );
};

export default Toast;